<template>
    <b-button v-on="$listeners" v-bind="$attrs" class="btn" variant="white">
        <template v-if="isIcon">
            <i :class="`icon fa fa-${icon} mr-2`" />
        </template>
        <slot>
            <span>{{ label }}</span>
        </slot>
    </b-button>
</template>

<script>
export default {
    name: 'BaseBtn',
    props: {
        icon: {
            type: String,
            require: false,
        },
        label: {
            type: String,
            require: false,
        },
    },
    computed: {
        isIcon() {
            return !!this.icon
        },
    },
}
</script>

<style lang="scss" scoped>
.icon {
    font-size: 14px;
    margin-bottom: 0;
}
.btn {
    display: flex;
    align-items: center;
    color: #009ada;
    font-size: 12px;
    font-weight: 400;
    border: 1px solid #009ada;
    white-space: nowrap;
}
</style>
